// productIndex — індексація товарів з blocks і резолв товару по action.

export function indexProductsFromBlocks(productIndexRef, nextBlocks) {
  const idx = productIndexRef.current || {};

  for (const b of nextBlocks || []) {
    const isProductsBlock =
      (b?.type === "product_list" || b?.type === "product_links") &&
      Array.isArray(b.products);

    if (!isProductsBlock) continue;

    for (const p of b.products) {
      const id = p?.variant_id || p?.id; // ✅ важливо: variant_id пріоритет
      if (!id) continue;

      idx[String(id)] = {
        id: String(id),
        name: p.name,
        price: p.price,
        image_url: p.image_url,
        image_proxy_url: p.image_proxy_url,
      };
    }
  }

  productIndexRef.current = idx;
}

export function resolveProduct(productIndexRef, action) {
  const id = action?.product_id;

  const p =
    action?.product ||
    productIndexRef.current?.[id] ||
    (id ? { id, name: id, price: 0 } : null);

  if (!p?.id) return null;

  return {
    id: p.id,
    name: p.name || p.id,
    price: typeof p.price === "number" ? p.price : Number(p.price) || 0,
    image_url: p.image_url,
    image_proxy_url: p.image_proxy_url,
  };
}